import React from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import { store, persistor } from "./state/store";
import NotFound from "./components/template/pages/notFound";
import publciShipment from "./components/Europartners/publicShipment/Embarques/ShipmentsDetail";

import "./App.scss";
import "antd/dist/antd.css";
import "./resources/semantic/theme/semantic-ui.css";
import "./styles/bootstrap.scss";
import "./styles/app.scss";

/*=============================================
=            App Component With Router        =
=============================================*/

const App = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter basename={"/"}>
        <Switch>
          <Route exact path="/not-found" component={NotFound} />
          <Redirect to="/not-found" />
          <Route exact path="/public" component={publciShipment} />
          <Route exact path="/" render={() => {
            window.location.href = "https://xpdglobal.com/en/global-logistics/";
            return null;
          }} />
          <Route component={NotFound} />
        </Switch>
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

export default App;
